import React, { FC } from 'react';

import { Container } from 'layout';
import CustomCurrentRefinements from 'common/CustomCurrentRefinements';
import Filters from 'common/Filters';
import CustomResultsHandler from 'common/Filters/CustomResultsHandler';
import SortingHits from 'common/SortingHits';

import CustomResultsAndPresentationHits from './CustomResultsAndPresentationHits';
import { ResultsAndPresentationsArticlesProps } from './models';

import './ResultsAndPresentationsArticles.scss';

const ResultsAndPresentationsArticles: FC<ResultsAndPresentationsArticlesProps> = ({
  viewPageLinkText,
  pressReleaseLinkText,
  lang,
  searchPlaceholder,
  searchText,
  yearsDropdownText,
  selectedFiltersText,
  numberOfResultsText,
  clearFiltersText,
  sortByText,
  mostRecentSortText,
  oldestSortText,
  loadMoreButtonText,
  noResultsText,
}) => (
  <section className="results-and-presentation-section">
    <Filters
      searchBtnText={searchText}
      selectedFiltersText={selectedFiltersText}
      searchPlaceholder={searchPlaceholder}
      firstFilterText={yearsDropdownText}
      filters={['year']}
      numberOfResultsText={numberOfResultsText}
      clearFiltersText={clearFiltersText}
    />
    <Container>
      <div className="sort-by-and-layout">
        <SortingHits
          sortByText={sortByText}
          firstValue={mostRecentSortText}
          secondValue={oldestSortText}
        />
      </div>
      <CustomCurrentRefinements />
    </Container>
    <CustomResultsHandler noResultsText={noResultsText}>
      <CustomResultsAndPresentationHits
        lang={lang}
        loadMoreText={loadMoreButtonText}
        viewPageLinkText={viewPageLinkText}
        pressReleaseLinkText={pressReleaseLinkText}
      />
    </CustomResultsHandler>
  </section>
);

export default ResultsAndPresentationsArticles;
